/*
 * Any value that's not available for MetService, regardless of its type, might return `n/a` as a string.
 * So, this string is to perform conditionals against this case.
 */
export const NA_VALUE = 'n/a';
export const DEFAULT_MAP_PIN_CLASSNAME = 'Map-tooltip svg-fill-font-color';
export const NO_DATA_BACKGROUND_COLOR = '#8b8b8b';
export const DEFAULT_STATION_BACKGROUND_COLOR = '#1D4B87';
export const HEX_WHITE = '#FFFFFF';
export const MAP_PIN_SVG =
  'M21.5 1A19.67 19.67 0 005 9.73a18.24 18.24 0 00-1.17 18.1c.4.756.854 1.48 1.36 2.17l15.65 22.66a.81.81 0 001.32 0l15.52-22.47a18.81 18.81 0 001.53-2.51 18.26 18.26 0 00-1.29-18A19.67 19.67 0 0021.5 1h0z';
